import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * The shared section header. Eyebrow, title, and an optional lead paragraph.
 *
 * Lives with the sections rather than in ui/ because it is a page-composition
 * pattern, not a shadcn primitive — putting it in ui/ invites someone to reach
 * for it inside a card or a dialog, where the type scale is wrong.
 */
export function SectionHeading({
  eyebrow,
  title,
  lead,
  align = "left",
  className,
}: {
  eyebrow?: string;
  title: ReactNode;
  lead?: ReactNode;
  align?: "left" | "center";
  className?: string;
}) {
  return (
    <div className={cn(align === "center" && "mx-auto max-w-2xl text-center", className)}>
      {eyebrow && (
        <p className="text-xs font-semibold uppercase tracking-[0.14em] text-brand">{eyebrow}</p>
      )}
      <h2 className="mt-2 text-3xl font-medium tracking-tight text-ink sm:text-4xl">{title}</h2>
      {lead && <p className="mt-4 text-lg leading-relaxed text-ink/65">{lead}</p>}
    </div>
  );
}
